<template>
  <div class="container">
    <!-- <top></top> -->
    <div class="align-center">
      <template v-for="item in componentImstances">
        <component :is="item.instance" :list="item.list" />
      </template>
    </div>
    <!-- <bottom></bottom> -->
  </div>
</template>

<script>
  import top from '@/components/top.vue'
  import bottom from '@/components/bottom.vue'
  export default {
    components: {
      top,
      bottom
    },
    data() {
      return {
        viewList: []
      }
    },
    computed: {
      componentImstances () {
        let {
          viewList
        } = this
        console.log(viewList)
        return viewList.map(item => {
          item.instance = () => import(`@/components/${item.name}`)
          return item
        })
      }
    },
    created() {
      if(sessionStorage.getItem('is_preview')){
        this.viewList = JSON.parse(sessionStorage.getItem('webTemplate'))
        return
      }
      this.getApi()
      // this.viewList = JSON.parse(sessionStorage.getItem('webTemplate')) || []
    },
    methods: {
      getApi(){
        let params = {
          page_type: 'index'
        }
        this.$api.get('/api/H5/website/pc_temp',{params:params}).then(res => {
        	this.viewList = res.data
        })
      },
    }
  }
</script>
<style lang="less" scoped>

  @media screen and (min-width: 1100px) {
    .container{
      width: 100%;
      min-width: 1250px;
      display: flex;
      justify-content: center;
      position: relative;
      overflow-x: hidden;
    }
    .align-center{
      width: 1250px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }
  @media screen and (max-width: 1100px) {

    .container{
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      overflow-x: hidden;
    }
    .align-center{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue